<template>
  <div class="container-table-striped">
    <div>
      <div v-if="!isAddMode">
        <div
          v-for="(item, index) in referralsRequest"
          :key="`${item.isOpen}_${index}`"
          class="row"
        >
          <div class="col-md-12">
            <callout :has-toggle="true" :opened="item.isOpen" class="mb-3 mt-1">
              <div class="row py-2">
                <div class="col-md-3 col-sm-12 pl-5">
                  <div class="font-weight-normal font-14 color-gray--6">
                    Tipo de Servicio:
                  </div>
                  <span class="font-weight-normal font-16 color-black--2">
                    {{ item.evaluation.name }}
                  </span>
                </div>
                <div class="col-md-3 col-sm-12">
                  <div class="font-weight-normal font-14 color-gray--6">
                    Servicio:
                  </div>
                  <span class="font-weight-normal font-16 color-black--2">
                    {{ item.discipline.name }}
                  </span>
                </div>
                <div class="col-md-3 col-sm-12">
                  <div class="font-weight-normal font-14 color-gray--6">
                    Estatus:
                  </div>
                  <em class="fa fa-circle font-10 color-yellow--1 pr-1" />
                  <span>{{ item.status }}</span>
                </div>
                <div class="col-md-3 col-sm-12 d-flex justify-content-end pr-5">
                  <ActionButton
                    v-if="item.studentReferralId != undefined"
                    variant="outline-success"
                    i="fas fa-print"
                    @click="printReferral(item)"
                  >
                    Imprimir
                  </ActionButton>
                  <ActionButton
                    v-if="
                      !isFromDetailCoordination &&
                        !submitted &&
                        item.referralStatusId == 1
                    "
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger m-2"
                    @click="deleteItem(item)"
                  >
                    Eliminar
                  </ActionButton>
                </div>
              </div>
              <template #edition>
                <div class="bg-gray p-2">
                  <div class="bg-white rounded p-3">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <em class="fas fa-info-circle text-orange mr-2" />
                        <span class="color-black--3 font-weight-bold font-16">
                          Razón de referido
                        </span>
                      </div>
                      <div class="col ml-4 mt-n3">
                        <CustomTextArea
                          v-if="canEditReferralReason(item)"
                          v-model="item.referralRequestReason"
                          :maxlength="5000"
                          :error="!item.referralRequestReason"
                          :custom-error-msg="
                            'Favor de escribir una razón para solicitar esta evaluación.'
                          "
                        />
                        <span
                          v-else
                          class="font-weight-normal font-16 color-black--2"
                        >
                          {{ item.referralRequestReason }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </callout>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <ValidationObserver v-if="isAddMode" ref="observer" novalidate>
          <ReferralForEvaluationRequestAdd
            :referrals-added="value"
            :sie="sie"
            @on-cancel="cancelReferral"
            @on-add="onAddReferralHandler"
          />
        </ValidationObserver>
      </div>
    </div>
    <div class="table-hover">
      <div
        v-if="!isAddMode && value.length == 0"
        class="mt-n4 bg-add-panel rounded"
      >
        <div class="col-12 text-center">
          <button
            class="btn bg-light-white w-50 pt-1 mt-2 button-add"
            @click="addReferral"
          >
            <i class="fas fa-file-plus pr-4 text-green" />
            <span class="text-button-add-document pt-4">
              Presione aquí para añadir solicitud de referidos
            </span>
          </button>
        </div>
      </div>
      <div v-if="!isAddMode && value.length > 0" class="text-right">
        <ActionButton
          v-if="!isFromDetailCoordination && !submitted && !disabled"
          i="fas fa-file-plus"
          variant="success m-2 pl-4 pr-4"
          @click="addReferral"
        >
          Añadir
        </ActionButton>
      </div>
      <div v-if="hasError" class="mt-3">
        <Error
          variant="no-border error-margin-left"
          message="Favor de añadir al menos un referido de tipo trianual. (22093)"
        />
      </div>
    </div>

    <!-- Modal -->
    <VerifyContactInformationPopup id="modalVerifyContactInformation" />
  </div>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import ReferralForEvaluationRequestAdd from './ReferralForEvaluationRequestAdd';
import { ActionButton, Error, CustomTextArea } from '@/components/common';
import VerifyContactInformationPopup from './VerifyContactInformationPopup';
import { ValidationObserver } from 'vee-validate';
import validationMixin from '@/mixin/validation.mixin.js';
import StudentStatuses from '@/utils/constants/reg/studentStatuses.js';
import Callout from '@/components/common/callout/View.vue';
import studentService from '@/modules/student/api';
export default {
  name: 'ReferralForEvaluationRequest',
  mixins: [alert, validationMixin],
  data() {
    return {
      isAddMode: false,
      statusStudent: null,
      referralsRequest: [],
      errors: [],
    };
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
      meta: {
        description: 'Arreglo de especialistas',
        example: '[{}]',
      },
    },
    hasError: {
      type: Boolean,
      default: () => false,
    },
    submitted: {
      type: Boolean,
      default: () => false,
    },
    sie: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    isFromDetailCoordination: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    isStudenElegible() {
      if (!this.isFromDetailCoordination) {
        if (this.$store.getters.SelectedStudent != null) {
          let status = this.$store.getters.SelectedStudent.status;
          switch (status) {
            case StudentStatuses.Inactivo:
              return false;
            case StudentStatuses.Egreso:
              return false;
            default:
              return true;
          }
        } else {
          return false;
        }
      } else {
        switch (this.statusStudent) {
          case StudentStatuses.Inactivo:
            return false;
          case StudentStatuses.Egreso:
            return false;
          default:
            return true;
        }
      }
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
  },
  methods: {
    registerLocalObservers() {
      this.observersForValidate = [
        { name: 'referralForEvaluation', observer: this.$refs.observer },
      ];
    },
    onAddReferralHandler(referral) {
      this.value.push(referral);
      this.isAddMode = false;
      this.$emit('on-referrals', this.value);
    },
    async getStudentInfo(studentSieId) {
      const { data } = await studentService.getStudentDetailsBySie(
        studentSieId,
        false
      );
      this.statusStudent = data.statusId;
    },
    async addReferral() {
      if (!this.$store.getters.SelectedStudent) {
        await this.getStudentInfo(this.sie);
      }
      if (!this.isStudenElegible) {
        this.ShowToast(
          'Error al crear referido.',
          `No podrá crear un nuevo referido ya que el estudiante se encuentra en estatus ${this.studentStatus}.`,
          'error'
        );
        return;
      }
      this.isAddMode = true;
    },
    cancelReferral() {
      this.isAddMode = false;
    },
    async isValid() {
      await this.referralsRequest.forEach(async (item) => {
        if (!item.referralRequestReason) {
          this.referralsRequest.find(
            (referral) => referral.studentReferralId === item.studentReferralId
          ).isOpen = true;
          this.referralsRequest = this.referralsRequest;
        }
      });
      let newlist = this.referralsRequest;
      this.referralsRequest = [];
      this.referralsRequest = newlist;
      const hasError = this.referralsRequest.some(
        (referral) => !referral.referralRequestReason
      );
      this.$emit('validReferral', !hasError);
      return !hasError;
    },
    async deleteItem(itemToRemove) {
      const self = this;

      const result = await self.ShowCancelModal(
        'Confirmación',
        '¿Desea eliminar el Referido? (0541)',
        'Si',
        'No'
      );

      if (result) {
        if (
          itemToRemove.evaluation.name == 'Evaluación Trianual' &&
          self.value.filter((x) => x.evaluation.name == 'Evaluación Trianual')
            .length == 1
        ) {
          self.ShowToast(
            '',
            'El Referido Trianual no puede ser eliminado ya que es necesario al menos un (1) referido de este tipo para completar el proceso de Análisis de Evaluación Existente.',
            'error'
          );
          return;
        }
        self.value.splice(
          self.value.findIndex((x) => x == itemToRemove),
          1
        );
        this.$emit('on-referrals', this.value);
        self.ShowToast(
          'Proceso exitoso.',
          'El referido fue eliminado exitosamente.',
          'success'
        );
      }
    },
    async printReferral(itemToPrint) {
      const self = this;
      let itemsToPrint = self.value.filter((x) => x === itemToPrint);

      if (itemsToPrint.length > 0)
        this.$emit('downloadReferralReport', itemsToPrint);
    },
    syncReferrals() {
      this.referralsRequest = [];

      this.value.forEach((item) => {
        item.isOpen = false;
        this.referralsRequest.push(item);
      });
    },
    canEditReferralReason(item) {
      return this.isFromDetailCoordination && item.referralStatusId == 4;
    },
  },
  components: {
    ActionButton,
    ReferralForEvaluationRequestAdd,
    Error,
    VerifyContactInformationPopup,
    ValidationObserver,
    Callout,
    CustomTextArea,
  },
  mounted() {
    this.syncReferrals();
  },
  watch: {
    value: {
      handler: function(val) {
        this.syncReferrals();
      },
      deep: true,
      immediate: true,
    },
    async isAddMode() {
      await this.sleep(10);
      this.registerLocalObservers();
    },
    submitted(isSubmitted) {
      if (isSubmitted && this.value.length > 0) {
        this.value.map((item) => {
          item.status = 'Nuevo';
          return item;
        });
      }
    },
  },
};
</script>

<style scoped>
.pl-status {
  padding-left: 69px !important;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.student-search-alert-error {
  background: none;
  border: none;
}

.header-spacing {
  margin-left: 130px;
}

.header-disipline {
  width: 346px;
}

.text-bold {
  letter-spacing: 0;
  color: #000 !important;
  opacity: 1;
  font-weight: 900 !important;
  float: left;
  width: 100%;
}

.table-line {
  margin-top: -20px;
}

.error-margin-left {
  margin-left: 15px !important;
}

.header-title {
  margin-top: 100px !important;
}
.bg-add-panel {
  background-color: #fafafa;
  padding: 30px;
}
</style>
